$(document).ready(function() {
  var answer = $('.answer');
  var question = $('.question');
  var faq_item = $('.faq-list');

  question.click(function(e) {
    var ths = $(this);
    var target = ths.next('.answer');
    var current_faq_item = $(this).closest('.faq-list')
    target.slideToggle();
    faq_item.not(current_faq_item).removeClass('active');
    $(this).closest('.faq-list').toggleClass('active');
  });
})
